/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { Icon } from "./styles";
import { MdClose } from "react-icons/md";
import ClickAway from "./ClickAway";
import "./Modal.css";

function Modal(props) {
  const {
    open,
    draggable = true,
    clickAway = true,
    header,
    body,
    footer,
    style = {},
  } = props;

  if (!open) {
    return;
  }

  return (
    <ClickAway
      _key={2}
      id={props.id}
      onClickAway={(e) => {
        if (!e && clickAway) props.onClose();
      }}
    >
      <Draggable
        onStart={() => draggable}
        bounds="#pdf-sheet-main--cont"
        handle={".modal-draggable"}
        defaultPosition={{
          x: props?.pos?.x || 0,
          y: props?.pos?.y || 0,
        }}
      >
        <div
          className={`paper modal-cont ${props?.className?.trim?.() || ""}`}
          style={{ ...style }}
        >
          <div className="modal-header--cont">
            {header || (
              <React.Fragment>
                <div className="modal-header-label modal-draggable">
                  {props.title}
                </div>
                <Icon
                  onClick={props.onClose}
                  style={{ position: "absolute", right: 0, top: 0 }}
                >
                  <MdClose />
                </Icon>
              </React.Fragment>
            )}
          </div>

          <div className="modal-body--cont">{body}</div>

          <div className="modal-footer--cont">{footer}</div>
        </div>
      </Draggable>
    </ClickAway>
  );
}

export default Modal;
